var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0381 11.375L16.9427 16.341C16.9389 16.6836 16.8595 17.0218 16.7094 17.3343C16.2321 18.2679 15.0071 18.7297 13.0398 18.7297H1.30451L0 26H13.0292C21.1426 26 25.4662 23.1611 26 17.4832L17.0381 11.375Z",
    fill: "#2D87F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 0.00550568L24.6955 8.12225H12.9708C10.5244 8.12225 9.227 8.9152 9.07852 10.5011C9.07328 10.5689 9.07328 10.637 9.07852 10.7048V10.8425L9.01489 16.25H8.98307L8.8558 16.1399L8.32552 15.7544L0 9.44934C0.530288 3.14978 4.8539 0 12.9708 0L26 0.00550568Z",
    fill: "#2D87F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidis);
export default __webpack_public_path__ + "static/media/SIDIS.d0f05a8a22533218b03938592164e4eb.svg";
export { ForwardRef as ReactComponent };